const handlebars = require('handlebars');
const { isMailtoURI, isURL } = require('validator');

const validLinkMergeTags = require('../../constants/validLinkMergeTags');

const EMAIL_PREFIX = 'mailto:';
const TELEPHONE_PREFIX = 'tel:';
const WWW_PREFIX = 'www.';

const LINK_KEY = 'link';

const sanitizeLinkMark = (mark) => {

	const { href, rel, target, title, id } = mark.attrs;

	// Check to make sure that the href is valid for the link...

	let safeHref = href.trim();

	if (safeHref.indexOf(WWW_PREFIX) === 0) {
		safeHref = `https://${safeHref}`;
	}

	let isValid = false;

	let hrefToValidate = safeHref;

	const hrefTemplate = handlebars.compile(hrefToValidate, {
		// Throw error if there are merge tags in the link that are not allowed
		strict: true,
	});

	try {

		hrefToValidate = hrefTemplate(validLinkMergeTags);

	} catch (error) {

		throw new Error(`Invalid "href" attribute for link mark: ${safeHref}`);

	}

	// Email URL
	if (hrefToValidate.indexOf(EMAIL_PREFIX) === 0) {

		isValid = isMailtoURI(hrefToValidate);

	// Telephone URL
	} else if (hrefToValidate.indexOf(TELEPHONE_PREFIX) === 0) {

		isValid = true;

	// Http,Https URL
	} else {

		isValid = isURL(hrefToValidate, { protocols: ['http', 'https'] });

	}

	if (!isValid) {
		throw new Error(`Invalid "href" attribute for link mark: ${safeHref}`);
	}

	const safeAttrs = {
		href: safeHref,
	};

	if (rel) {
		safeAttrs.rel = rel;
	}

	if (target) {
		safeAttrs.target = target;
	}

	if (id) {
		safeAttrs.id = id;
	}

	if (title) {
		safeAttrs.title = title;
	}

	mark.attrs = safeAttrs;

	return mark;

};

const LinkMarkSpec = {
	attrs: {
		href: {
			default: null,
		},
		rel: {
			default: 'noopener noreferrer nofollow',
		},
		target: {
			default: '_blank',
		},
		title: {
			default: null,
		},
		id: {
			default: null,
		},
	},
	inclusive: false,
	parseDOM: [{
		tag: 'a[href]',
		getAttrs(dom) {
			return {
				id: dom.getAttribute('id'),
				href: dom.getAttribute('href'),
				title: dom.getAttribute('title'),
				target: dom.getAttribute('target'),
			};
		},
	}],
	toDOM(mark) {

		const safeMark = sanitizeLinkMark(mark);

		return ['a', safeMark.attrs, 0];

	},
};

module.exports = {
	LinkMarkSpec,
	LINK_KEY,
	sanitizeLinkMark,
};
